module.exports = __webpack_public_path__ + "img/LTS_EY.2c6644e8.gif";